import React, { ComponentPropsWithoutRef } from 'react';
import { OverflowText } from '../../../../components/OverflowText';
import { Text, TextAppearance, TextProps } from '../../../../components/Text';
import { identifyComponent } from '../../../../util';

type AllowedTags = 'span' | 'div';
type TextStyles<A extends TextAppearance> = {
  appearance?: A;
} & Pick<TextProps<A, AllowedTags>, 'color' | 'noWrap' | 'align' | 'tag' | 'testId'> &
  ComponentPropsWithoutRef<AllowedTags>;

interface DefaultCellContentProps<A extends TextAppearance> {
  label?: string | number;
  textStyles?: TextStyles<A>;
  /** If true, then content will be cut off and the full content will be shown in a tooltip */
  overflowViaTooltip?: boolean;
}

export const DefaultCellContent = <A extends TextAppearance>({
  label,
  textStyles,
  overflowViaTooltip,
}: DefaultCellContentProps<A>) => (
  <Text
    data-component="DefaultCellContent"
    appearance="bodyMedium"
    tag="span"
    {...textStyles}
    {...identifyComponent('table-cell-content')}
  >
    {overflowViaTooltip ? <OverflowText>{label}</OverflowText> : label}
  </Text>
);
